  import { useState, useEffect } from 'react';
import { useAuth } from '../../../app/providers';
// import { useNavigate } from '@tanstack/react-router';
// import { Navbar } from '../../../shared/components/layout';
import { roleApi, type RoleOption } from '../api';
import { useRoleUpdate } from '../hooks/useOnboardingMutations';

const RoleSelectionPage = () => {
  const [roles, setRoles] = useState<RoleOption[]>([]);
  const [selectedRole, setSelectedRole] = useState<string>('');
  const [error, setError] = useState<string>('');
  const { user } = useAuth();
  const { mutate: updateRole, isPending: isLoading } = useRoleUpdate();

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const availableRoles = await roleApi.getAvailableRoles();
        setRoles(availableRoles);
      } catch (err) {
        console.error(err);
        setError('Failed to load roles');
      }
    };
    fetchRoles();
  }, []);

  const handleRoleSelect = async (role: string) => {
    setSelectedRole(role);
    setError('');

    try {
      await updateRole({ role: role as any });
    } catch (err: any) {
      setError(err.message || 'Failed to update role');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      
      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Welcome Section */}
        <div className="text-center mb-6 md:mb-12">
          <h1 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4">
            Welcome {user?.name}!
          </h1>
          <p className="text-lg md:text-xl text-gray-600">
            Start managing your sober living community with ease.
          </p>
        </div>

        {/* Role Selection */}
        <div className="">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-5 md:mb-8">Setup as</h2>
          
          {error && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-red-600 text-sm">{error}</p>
            </div>
          )}
          
          <div className="space-y-6">
            {roles.map((role) => (
              <div
                key={role.id}
                className={`bg-white rounded-lg shadow-sm border-2 p-6 cursor-pointer transition-all duration-200 ${
                  selectedRole === role.id
                    ? 'border-[#5761EB] bg-[#5761EB]/5'
                    : 'border-gray-200 hover:border-[#5761EB]/50 hover:shadow-md'
                }`}
                onClick={() => handleRoleSelect(role.id)}
              >
                <div className="flex flex-col md:flex-row items-center gap-4 md:items-start justify-between">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-[#5761EB]/10 rounded-full flex items-center justify-center text-2xl">
                      {role.icon}
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">
                        {role.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {role.description}
                      </p>
                    </div>
                  </div>
                  <button
                    className={`px-6 py-2 rounded-lg font-medium transition-colors ${
                      selectedRole === role.id
                        ? 'bg-[#5761EB] text-white'
                        : 'bg-[#5761EB]/10 text-[#5761EB] hover:bg-[#5761EB]/20'
                    }`}
                    disabled={isLoading}
                  >
                    {isLoading && selectedRole === role.id ? 'Setting up...' : 'Continue'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default RoleSelectionPage;